import React from "react";
import {About,Meet_team,Recog} from "../components";
import "./../App.css";
const About_us = () => {
  return (
    <div>
      <About />
      
       <Meet_team />
    

    </div>
  );
};

export default About_us;
